import React from 'react';

import Grid from '@mui/material/Grid';
import { useFormikContext } from 'formik';

import TailNumberField from './TailNumberField';
import AircraftModelField from './AircraftModelField';
import { VspeedFormValues } from './VspeedFormValues';
import { DebriefAircraft } from 'ff/debrief/models';

interface Props {
    modelList: DebriefAircraft[];
    onTailChange: (
        values: VspeedFormValues,
        setFieldValue?: (field: string, value: unknown) => void
    ) => Promise<DebriefAircraft | void>;
    onAircraftModelChange: (
        values: VspeedFormValues,
        setFieldValue?: (field: string, value: unknown) => void
    ) => Promise<void>;
}

const AircraftForm = (props: React.PropsWithChildren<Props>) => {
    const { values, setFieldValue, validateForm } =
        useFormikContext<VspeedFormValues>();

    const handleTailChange = async (newTail: typeof values.tailNumber) => {
        await setFieldValue('tailNumber', newTail);
        await props.onTailChange(
            { ...values, tailNumber: newTail },
            setFieldValue
        );

        // validates form after all setFieldValue calls complete
        setTimeout(() => {
            validateForm();
        }, 0);
    };

    const handleAircraftModelChange = async (
        newModel: typeof values.aircraftModel
    ) => {
        await setFieldValue('aircraftModel', newModel);
        await props.onAircraftModelChange(
            { ...values, aircraftModel: newModel },
            setFieldValue
        );
    };

    return (
        <Grid container mb={2}>
            <Grid size={5}>
                <TailNumberField
                    value={values.tailNumber}
                    onChange={handleTailChange}
                />
            </Grid>
            <Grid size={7}>
                <AircraftModelField
                    value={values.aircraftModel}
                    onChange={handleAircraftModelChange}
                />
            </Grid>
        </Grid>
    );
};

export default AircraftForm;
